export default __webpack_public_path__ + "10c7a2eb8b8a74907fe78d291e547a71.png";